var Backbone, SharedSpinnerTemplate, SharedSpinnerView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedSpinnerTemplate = require('../../spinner.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SharedSpinnerView = (function(superClass) {
  extend(SharedSpinnerView, superClass);

  function SharedSpinnerView() {
    return SharedSpinnerView.__super__.constructor.apply(this, arguments);
  }

  SharedSpinnerView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedSpinnerTemplate;
  };

  SharedSpinnerView.prototype.show = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$el.html(toHtml(this.template, hash, this.I18nScope));
      if (hash.append) {
        this.$container.append(this.$el);
      } else {
        this.$container.html(this.$el);
      }
      if (hash.height) {
        this.$el.css('height', hash.height);
        $('.g-spinner', this.$el).css('height', hash.height);
      }
      if (hash.id) {
        return this.$el.attr('id', hash.id);
      }
    }
  };

  SharedSpinnerView.prototype.hide = function() {
    return this.$el.empty();
  };

  SharedSpinnerView.prototype.remove = function() {
    return this.$el.remove();
  };

  return SharedSpinnerView;

})(Backbone.View);

module.exports = SharedSpinnerView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9zcGlubmVyX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9zcGlubmVyX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsa0RBQUE7RUFBQTs7O0FBQUEscUJBQUEsR0FBd0IsT0FBQSxDQUFRLDZCQUFSOztBQUN4QixRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFFUDs7Ozs7Ozs4QkFFSixVQUFBLEdBQWEsU0FBQTtJQUNYLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO0VBRkQ7OzhCQUliLElBQUEsR0FBTyxTQUFDLElBQUQ7SUFDTCxJQUFHLGdEQUFIO01BQ0UsSUFBQyxDQUFBLFVBQUQsR0FBYyxJQUFJLENBQUM7TUFDbkIsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQWxCLEVBQXdCLElBQUMsQ0FBQSxTQUF6QixDQUFWO01BRUEsSUFBRyxJQUFJLENBQUMsTUFBUjtRQUNFLElBQUMsQ0FBQSxVQUFVLENBQUMsTUFBWixDQUFtQixJQUFDLENBQUEsR0FBcEIsRUFERjtPQUFBLE1BQUE7UUFHRSxJQUFDLENBQUEsVUFBVSxDQUFDLElBQVosQ0FBaUIsSUFBQyxDQUFBLEdBQWxCLEVBSEY7O01BS0EsSUFBRyxJQUFJLENBQUMsTUFBUjtRQUNFLElBQUMsQ0FBQSxHQUFHLENBQUMsR0FBTCxDQUFTLFFBQVQsRUFBbUIsSUFBSSxDQUFDLE1BQXhCO1FBQ0EsQ0FBQSxDQUFFLFlBQUYsRUFBZ0IsSUFBQyxDQUFBLEdBQWpCLENBQXFCLENBQUMsR0FBdEIsQ0FBMEIsUUFBMUIsRUFBb0MsSUFBSSxDQUFDLE1BQXpDLEVBRkY7O01BR0EsSUFBRyxJQUFJLENBQUMsRUFBUjtlQUNFLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLElBQVYsRUFBZ0IsSUFBSSxDQUFDLEVBQXJCLEVBREY7T0FaRjs7RUFESzs7OEJBaUJQLElBQUEsR0FBTyxTQUFBO1dBQ0wsSUFBQyxDQUFBLEdBQUcsQ0FBQyxLQUFMLENBQUE7RUFESzs7OEJBR1AsTUFBQSxHQUFTLFNBQUE7V0FDUCxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBQTtFQURPOzs7O0dBMUJxQixRQUFRLENBQUM7O0FBNkJ6QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
